/** @jsxImportSource @emotion/react */
import * as S from './styled/Timeline.styled';

/**
 * @author Burak Unsal
 */

const Timeline = ({ children, hasNumber = false }) => <S.Container hasNumber={hasNumber}>{children}</S.Container>;

export const TimelineItem = (props) => {
	const { itemCss, children, alignment = 'center', lineNumber = 0, isLastItem = false } = props;
	return (
		<S.Item css={itemCss} alignment={alignment}>
			<S.SeparatorNoHeight className="timeline-separator">
				{lineNumber > 0 && <S.LineNumber className="line-number">{lineNumber}</S.LineNumber>}
				{!isLastItem && <S.SeparatorLineNoHeight className="timeline-separator-line" />}
			</S.SeparatorNoHeight>
			<S.Content alignment={alignment}>{children}</S.Content>
			{!lineNumber && (
				<S.Separator className="timeline-separator">
					{lineNumber > 0 && <S.LineNumber className="line-number">{lineNumber}</S.LineNumber>}
					{!isLastItem && <S.SeparatorLine className="timeline-separator-line" />}
				</S.Separator>
			)}
		</S.Item>
	);
};

export default Timeline;
